export function checkIsNotNullish<Input>(input: Input | undefined | null): input is NonNullable<Input> {
  return input != null;
}
